import { StyledPayoutListControls } from './styles';
interface IPayoutListControlsProps {
  children?: React.ReactNode;
}
export const PayoutListControls = ({ children }: IPayoutListControlsProps) => {
  return <StyledPayoutListControls>{children}</StyledPayoutListControls>;
};
